function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDelete = function SvgDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.293 9l6.585-6.585a.418.418 0 000-.59L16.174.123a.418.418 0 00-.589 0L9 6.707 2.415.122a.418.418 0 00-.59 0L.121 1.826a.418.418 0 000 .589L6.707 9 .122 15.585a.416.416 0 000 .588l1.704 1.704a.416.416 0 00.59 0L9 11.292l6.585 6.585a.416.416 0 00.59 0l1.703-1.704a.416.416 0 000-.588L11.293 9",
    fill: props.fill
  }));
};
export default SvgDelete;